import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const expectedRole = route.data.role;
    // console.log('expeted: ', expectedRole);

    return this.auth.user.pipe(
      take(1),
      map(user => {
        // console.log('user in guard: ', user);
        if(!user) {
          this.router.navigateByUrl('/login');
          return false;
        } else {
          let role = user['role'];
          if(expectedRole == role) {
            return true;
          } else {
            this.router.navigateByUrl('/login');
            return false;
          }
        }
      })
    )
  }
  
}
